//@flow
import type { AppState } from 'quick-quote/reducers'
import _ from 'lodash'
import {
  getSelectedDisplayProductCode,
  getSelectedDisplayProductCategory,
  getSelectedDisplayProduct,
} from 'quick-quote/product-selection/selectors'
import { getAppConfig } from 'deploy-env/app-config'

import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'

import VALUES from 'core/data-model/constants/values'

import viewerUrl from 'file-loader?name=pdf-viewer/web/viewer.html&emitFile=false!e-submission/pdf-viewer/web/viewer.html'
import { iInvestBase64Pdf, iLinkBase64Pdf, iWealthyBase64Pdf } from '../constants/ilp-pdf-base64'

const SALE_SHEET_PDF_NAME = {
  RPUDR: iLinkBase64Pdf, // iLink
  SPUL: iInvestBase64Pdf, // iInvest
  RPUL: iWealthyBase64Pdf, // iWealthy
}

const convertBase64PdfToBlobUrl = (base64string) => {
  const base64Data = base64string.split(',')[1]
  const binaryData = atob(base64Data)
  const byteArr = new Uint8Array(binaryData.length)
  for (let i = 0; i < binaryData.length; i++) {
    byteArr[i] = binaryData.charCodeAt(i)
  }
  const blobbbbb = new Blob([byteArr], { type: 'application/pdf' })
  const bloburl = URL.createObjectURL(blobbbbb)

  return bloburl
}

const onLoadIframe = (evt) => {
  const iframe = evt.target
  const iframeDocument = iframe.contentWindow.document
  const toolbar = iframeDocument.querySelector('.toolbar')
  const content = iframeDocument.querySelector('#viewerContainer')

  toolbar.style.visibility = 'hidden'
  content.style.top = 0

  iframeDocument.body.setAttribute('data-doc-name', 'ilp-sale-sheet-pdf')
  iframeDocument.body.setAttribute('data-readonly', 'true')
}

export const Component = ({ saleSheetBlobUrl }) => {
  return (
    <div id="salesheetviewer" style={{ display: 'flex', overflow: 'auto', flex: 1 }}>
      <iframe
        style={{ width: '100%' }}
        src={`${viewerUrl}?file=${saleSheetBlobUrl}`}
        onLoad={(evt) => onLoadIframe(evt)}
      />
    </div>
  )
}

const mapStateToProps = (state: AppState) => ({
  selectedDisplayProduct: getSelectedDisplayProduct(state),
  selectedDisplayProductCategory: getSelectedDisplayProductCategory(state),
  selectedDisplayProductCode: getSelectedDisplayProductCode(state),
})

const mapDispatchToProps = (dispatch: Dispatch<*>) => ({})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('saleSheetBlobUrl', 'setSaleSheetBlobUrl', ''),
  lifecycle({
    componentDidMount() {
      const { setSaleSheetBlobUrl, selectedDisplayProductCode, selectedDisplayProductCategory } = this.props

      if (selectedDisplayProductCategory === VALUES.INVESTMENT) {
        const pdfBase64 = SALE_SHEET_PDF_NAME[selectedDisplayProductCode]
        const pdfFileBlobUrl = convertBase64PdfToBlobUrl(pdfBase64)
        setSaleSheetBlobUrl(pdfFileBlobUrl)
      }
    },
  })
)(Component)
